import router from './router';
import store from './store';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth';
const whiteList = ['/login', '/register'];
router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      //如果已登陆跳转默认页面
      next({ path: '/' });
    } else {
      if (store.getters.roles || store.getters.roles === 0) {
        //roles有获取到数据就继续访问路由
        let result = await checkAdmin(to, next); //检测是否有进入admin权限
        if (!result) {
          next();
        }
      } else {
        //获取roles数据，重新生成roles能访问的路由
        try {
          // 获取角色
          //const { roles } = await store.dispatch('user/userinfo')
          const {
            roles,
            allow_oem,
            is_superuser,
            allow_offline,
            is_maintainer,
            allow_xzreport,
            allow_af,
            admin,
            agent_info,
          } = await store.dispatch('user/userinfo');
          
          // 根据角色生成路由
          const accessRoutes = await store.dispatch('permission/generateRoutes', {
            roles,
            allow_oem,
            is_superuser,
            allow_offline,
            is_maintainer,
            allow_xzreport,
            admin,
            allow_af,
            agent_info
          });
          // 动态添加路由
          router.addRoutes(accessRoutes);
          // hack method 确保路由完整
          next({ ...to, replace: true });
        } catch (error) {
          console.log(error, 'error');
          await store.dispatch('user/resetToken');

          Message.error(error || 'Has Error');
          next(`/login`);
        }
      }
    }
  } else {
    //无权限页面处理
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login`);
    }
  }
});
const checkAdmin = async (to, next) => {
  let result = false;
  if (to.path.indexOf('admin') !== -1) {
    result = true;
    if (store.getters.admin) {
      next();
    } else {
      const { admin } = await store.dispatch('user/userinfo');
      if (admin) {
        next();
      } else {
        next(`/`);
      }
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/permission.js